module.exports = __webpack_public_path__ + "img/inbound_w.478a6855.png";